import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsMembershipDetails from "./components/SettingsMembershipDetails";

const SettingsMembershipDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsMembershipDetails {...props} />
    </>
  );
};

export default SettingsMembershipDetailsApp;
